import { useNavigate } from "react-router-dom";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: 40,
        color: "white",
        maxWidth: "900px",
        margin: "auto",
        lineHeight: "1.8",
      }}
    >
      <button
        onClick={() => navigate(-1)}
        style={{
          background: "transparent",
          color: "white",
          border: "1px solid rgba(255,255,255,0.35)",
          padding: "8px 14px",
          borderRadius: "10px",
          marginBottom: "24px",
          cursor: "pointer",
        }}
      >
        ← Back
      </button>

      <h1>Terms and Conditions</h1>

      <p>Last updated: May 2026</p>

      <p>
        Welcome to AskUniverse, operated by SC IMAA 888 SRL, Romania.
        By accessing or using the AskUniverse application, website,
        or related services, you agree to these Terms and Conditions.
        Please read them carefully before using the service.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using AskUniverse, you confirm that you accept these Terms and Conditions.
        If you do not agree with these terms, please do not use the application.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old or have the consent of a parent
        or legal guardian to use AskUniverse.
      </p>

      <h2>3. Services Provided</h2>
      <p>
        AskUniverse provides AI-generated content, including dream interpretations,
        tarot-inspired guidance, spiritual insights, daily messages,
        Love Portal experiences, soulmate and twin flame interpretations,
        relationship reflection tools, and interactive experiences for informational,
        inspirational, entertainment, and self-reflection purposes only.
      </p>

      <h2>4. No Professional Advice</h2>
      <p>
        AskUniverse does not provide medical, psychological, legal,
        financial, or professional advice of any kind.
        Users should consult qualified professionals where appropriate.
        AskUniverse does not guarantee romantic outcomes, relationship compatibility,
        emotional accuracy, or real-world interpersonal results.
      </p>

      <h2>5. AI-Generated Content</h2>
      <p>
        AI-generated responses may contain inaccuracies, incomplete information,
        or interpretations that should not be treated as factual certainty.
        We do not guarantee the accuracy or reliability of any generated content.
      </p>

      <h2>6. User Accounts</h2>
      <p>
        Users are responsible for maintaining the confidentiality of their accounts
        and login credentials. We reserve the right to suspend or terminate accounts
        that violate these Terms.
      </p>

      <h2>7. Premium Services and Payments</h2>
      <p>
        Certain features may require a Premium subscription.
        Payments are securely processed through third-party providers such as Stripe.
        Subscriptions may renew automatically unless canceled before renewal.
      </p>

      <h2>8. Intellectual Property</h2>
      <p>
        All content, branding, design elements, software,
        and functionality of AskUniverse are protected intellectual property
        owned or licensed by SC IMAA 888 SRL unless otherwise stated.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        AskUniverse is provided "as is" without warranties of any kind.
        We are not responsible for decisions, actions, or outcomes resulting
        from the use of the application or AI-generated content.
      </p>

      <h2>10. Changes to Terms</h2>
      <p>
        We reserve the right to update or modify these Terms and Conditions
        at any time. Continued use of AskUniverse after changes are published
        constitutes acceptance of the updated Terms.
      </p>

      <h2>11. Contact</h2>
      <p>
        SC IMAA 888 SRL <br />
        Romania <br />
        support@askuniverse.app
      </p>

      <p style={{ marginTop: "40px", opacity: 0.7 }}>
        ©️ 2026 AskUniverse. All rights reserved.
      </p>
    </div>
  );
}
